import React from 'react'
import { HeroSection } from '../components/eventPage/HeroSection'
import { UpcomingEvents } from '../components/eventPage/UpcomingEvents'
export const Event = () => {

  

  return (
    <>
        <HeroSection/>
        <div>
          <UpcomingEvents/>
        </div>
    </>
  )
}
